module.exports = __webpack_public_path__ + "static/media/funds-blue.459cbde4.svg";